import { createContext, ReactNode, useContext, useMemo } from 'react';

interface ProjectSnackbarContextType {
    setSnackbarMessage: (message: string | null) => void;
}

const ProjectSnackbarContext = createContext<ProjectSnackbarContextType | undefined>(undefined);

export const useProjectSnackbar = () => {
    const context = useContext(ProjectSnackbarContext);
    if (!context) {
        throw new Error('useProjectSnackbar must be used within ProjectSnackbarProvider');
    }

    return context;
};

interface ProjectSnackbarProviderProps {
    children: ReactNode;
    setSnackbarMessage: (message: string | null) => void;
}

export const ProjectSnackbarProvider = ({ children, setSnackbarMessage }: ProjectSnackbarProviderProps) => {
    const value = useMemo(() => ({ setSnackbarMessage }), [setSnackbarMessage]);

    return <ProjectSnackbarContext.Provider value={value}>{children}</ProjectSnackbarContext.Provider>;
};
